// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1Tsc3","col":"CardReaderDesc_col__M-7Bj","label":"CardReaderDesc_label__35XQP"};